module.exports = __webpack_public_path__ + "img/Runner.3daa2540.gif";